import React from "react";

import Routes from "./pages/Root";

function App() {
  return <Routes />;
}

export default App;
